import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AccessLevel } from '../../../../constants/AccessLevels';

import { Dashboard } from '../../../common';
import Widget from '../../Widget/Widget';

import {
   Views,
   ErrorCodes,
   BufferingRatio,
   PlayerLoadings,
   LatencyPercentiles,
   LatencyStats,
   StartupTimeStats,
   StopReason,
   PlaytimeStats,
   PlaytimeBreakdown,
} from '../../../widgets/h5live';

import { PlayerVersion } from '../../../widgets/common';

import { Col, Row } from 'reactstrap';

import storePropTypes from './../../../../redux/store/propTypes';

import axios from 'axios';
import { setNewCancelToken, setViewTimespan } from './../../../../redux/actions/general';

import { PropTypes } from 'prop-types';
import { H5LIVE_VIEW } from '../../../../constants/general';
import { BROWSER, OS } from '../../../../constants/dataGroup';

const mapStateToProps = (state) => {
   return state.general;
};

const mapDispatchToProps = { setNewCancelToken, setViewTimespan };

class H5Live extends Component {
   componentWillUnmount() {
      // cancel token, added to old requests, will be activated --> old requests will be cancelled
      this.props.cancelToken.cancel('Operation canceled by the user.');
      this.props.setViewTimespan(H5LIVE_VIEW);
      this.props.setNewCancelToken(axios.CancelToken.source());
   }

   render() {
      return (
         <Dashboard location={this.props.location} history={this.props.history} view={H5LIVE_VIEW}>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={Views}
                     requiredLevel={AccessLevel.FULL}
                     widgetAttributes={{ data: { grouping: OS }, height: 300 }}
                  />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={Views}
                     requiredLevel={AccessLevel.FULL}
                     widgetAttributes={{ data: { grouping: BROWSER }, height: 300 }}
                  />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={PlaytimeBreakdown}
                     requiredLevel={AccessLevel.FULL}
                     widgetAttributes={{ data: { grouping: OS }, height: 300 }}
                  />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={PlaytimeBreakdown}
                     requiredLevel={AccessLevel.FULL}
                     widgetAttributes={{ data: { grouping: BROWSER }, height: 300 }}
                  />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={PlaytimeStats} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={BufferingRatio} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={PlayerLoadings} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={PlayerVersion}
                     requiredLevel={AccessLevel.FULL}
                     widgetAttributes={{ usedApp: H5LIVE_VIEW, height: 300 }}
                  />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={LatencyStats} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={StartupTimeStats} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={ErrorCodes} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget type={StopReason} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
               </Col>
            </Row>
            <Row className='animated fadeIn'>
               <Col xs='12' sm='12' md='12' lg='6' xl='6'>
                  <Widget
                     type={LatencyPercentiles}
                     requiredLevel={AccessLevel.ADMIN}
                     widgetAttributes={{ height: 300 }}
                  />
               </Col>
            </Row>
         </Dashboard>
      );
   }
}

H5Live.propTypes = {
   cancelToken: storePropTypes.cancelToken,
   setNewCancelToken: PropTypes.func,
   setViewTimespan: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(H5Live);
